import { Link } from "react-router-dom";
import { mockVideos } from "@/mocks/videos";

interface VideoGridProps {
  title: string;
  subtitle?: string;
  videos: typeof mockVideos;
  linkTo?: string;
}

export default function VideoGrid({ title, subtitle, videos, linkTo }: VideoGridProps) {
  return (
    <section className="py-8 md:py-10 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-2">
            <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">{title}</h2>
            {subtitle && <span className="text-sm text-foreground-500 ml-2 hidden sm:inline">{subtitle}</span>}
          </div>
          {linkTo && (
            <Link to={linkTo} className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap">
              查看更多 <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {videos.slice(0, 8).map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 bg-black/65 backdrop-blur-sm text-white text-[10px] px-1.5 py-0.5 rounded font-medium">
                  {video.duration}
                </div>
                <div className="absolute bottom-2 left-2">
                  <span className="bg-primary-500 text-white text-[10px] px-2 py-0.5 rounded-full font-medium">
                    {video.views >= 10000 ? `${(video.views / 10000).toFixed(1)}万` : video.views.toLocaleString()} 观看
                  </span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center gap-2 mt-2">
                  <span className="text-xs text-foreground-500">{video.date}</span>
                  {video.tags && video.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="text-[10px] text-secondary-700 bg-secondary-100 px-1.5 py-0.5 rounded">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}